import AdminUsers from "./componets/AdminUsers";
import "./index.css";
import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import Layout from "./componets/Layout";
import Home from "./pages/Home";
import Shopify from "./pages/Shopify";
import Shopify_ny from "./pages/Shopify-ny";
import Shopify_Texas from "./pages/Shopify-Texas";
import Magento from "./pages/Magento";
import BigCommerce from "./pages/BigCommerce";
import WooCommerce from "./pages/WooCommerce";
import WordpressDevelopment from "./pages/WordpressDevelopment";
import MobileAppDevelopment from "./pages/MobileAppDevelopment";
import GameDesignAndDevelopment from "./pages/GameDesignAndDevelopment";
import Erp from "./pages/Erp";
import HostingAndCloudServices from "./pages/HostingAndCloudServices";
import PluginAndAppDevelopment from "./pages/PluginAndAppDevelopment";
import PerformanceMarketing from "./pages/PerformanceMarketing";
import PerformanceMarketing_ny from "./pages/PerformanceMarketing-ny";
import PerformanceMarketing_Texas from "./pages/PerformanceMarketing-Texas";
import Tiktok from "./pages/Tiktok";
import Seo from "./pages/Seo";
import Seo_ny from "./pages/Seo_ny";
import Seo_Texas from "./pages/Seo-Texas";
import InfluencerMarketing from "./pages/InfluencerMarketing";
import SocialMediaMarketing from "./pages/SocialMediaMarketing";
import ConversionRateOptimization from "./pages/Conversion-rate-optimization";
import EmailMarketing from "./pages/EmailMarketing";
import LogoAndBranding from "./pages/LogoAndBranding";
import PrintDesignAndService from "./pages/PrintDesignAndService";
import ProductAndMerchandise from "./pages/ProductAndMerchandise";
import BannersAndAdvertisement from "./pages/Banners-and-advertisement";
import UiAndUxDesign from "./pages/UiAndUxDesign";
import StaffAugmentationService from "./pages/StaffAugmentationService";
import ProjectOutsourcing from "./pages/ProjectOutsourcing";
import CctvSurveillance from "./pages/CcctvSurveillance";
import AiInEcommerce from "./pages/AiInEcommerce";
import VirtualAssistant from "./pages/VirtualAssistant";
import Clients from "./pages/Clients";
import Testimonial from "./pages/Testimonial";
import Blogs from "./pages/Blogs";
import Career from "./pages/Career";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Faq from "./pages/Faq";
import News from "./pages/News";
import InfluencerRegistrationForm from "./pages/InfluencerRegistrationForm";
import Media from "./pages/OurGallery";
// import BlogDetails from "./pages/BlogDetails";
// import Blogs from "./pages/Blogs";
import BlogDetailsCard from "./componets/BlogDetailsCard/BlogDetailsCard";
import WebDevelopment from "./pages/Web-Developement";
import WebDevelopment_ny from "./pages/Web-Developement-ny";
import WebDevelopment_Texas from "./pages/Web-Developement-texas";
import { ToastContainer } from "react-toastify";
import CaseStudies from "./pages/CaseStudies";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import MBGPage from "./pages/MBGPage";
import ShopifyPlus from "./pages/ShopifyPlus";
import ShopifyPlus_ny from "./pages/ShopifyPlus_ny";
import ShopifyPlus_Texas from "./pages/ShopifyPlus-Texas";
import PrivacyPolicy from "./pages/PrivacyPolicy/CsVgo";
import PrivacyPolicy1 from "./pages/PrivacyPolicy/UrbanPick";
import OFSBackSortPrivacyPolicy from "./pages/PrivacyPolicy/Ofs";
import OptimumCheckout from "./pages/PrivacyPolicy/optimum-checkout";
import SmartStockPrivacyPolicy from "./pages/PrivacyPolicy/smart-stock";
import EmployeeDiscountPrivacyPolicy from "./pages/PrivacyPolicy/EmployeeDiscountPrivacyPolicy";
import SmartCampaignPrivacyPolicy from "./pages/PrivacyPolicy/SmartCampaignPrivacyPolicy";
import EoceanPrivacyPolicy from "./pages/PrivacyPolicy/EoceanPrivacyPolicy";
import FakeOrderShield from "./pages/PrivacyPolicy/fake-order-shield";
import CheckoutBoostPrivacyPolicy from "./pages/PrivacyPolicy/Mean3CheckoutBoostPrivacyPolicy";
import BulkGiftPrivacyPolicy from "./pages/PrivacyPolicy/BulkGift";
import PingMePrivacyPolicy from "./pages/PrivacyPolicy/PingMe";
import UserProfilePage from "./pages/UserProfile/UserProfilePage";
import Canonical from "./componets/CanonicalTag";
import NotFound from "./componets/NotFound";
import WebNewYorkPage from "./pages/WebNewYorkPage";
import ThankYou from "./pages/ThankYou";
import AdminBlogs from "./pages/AdminBlogs";
import AdminLayout from "./componets/AdminLayout";
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./componets/ProtectedRoute";
import RoleRoute from "./componets/RoleRoute";
import FloatingButtons from "./componets/FloatingButtons";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer position="top-center" autoClose={3000} />
        <Canonical />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/shopify-website-development" element={<Shopify />} />
            <Route
              path="/shopify-website-development-ny"
              element={<Shopify_ny />}
            />
            <Route
              path="/shopify-website-development-Texas"
              element={<Shopify_Texas />}
            />
            <Route path="/shopify-plus-development" element={<ShopifyPlus />} />
            <Route
              path="/shopify-plus-development-ny"
              element={<ShopifyPlus_ny />}
            />
            <Route
              path="/shopify-plus-development-Texas"
              element={<ShopifyPlus_Texas />}
            />
            {/* <Route path="/shopify-plus-development" element={<ShopifyPlus plus={true} />} /> */}
            <Route path="/magento-website-development" element={<Magento />} />
            <Route
              path="/bigcommerce-development-services"
              element={<BigCommerce />}
            />
            <Route
              path="/woocommerce-development-services"
              element={<WooCommerce />}
            />
            <Route
              path="/website-design-and-development"
              element={<WebDevelopment />}
            />
            <Route
              path="/website-design-and-development-ny"
              element={<WebDevelopment_ny />}
            />
            <Route
              path="/website-design-and-development-Texas"
              element={<WebDevelopment_Texas />}
            />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-study/:title" element={<CaseStudyDetail />} />
            <Route path="/case-study/mbg" element={<MBGPage />} />
            <Route
              path="/wordpress-web-development"
              element={<WordpressDevelopment />}
            />
            <Route
              path="/mobile-application-development-services"
              element={<MobileAppDevelopment />}
            />
            <Route
              path="/game-design-and-development"
              element={<GameDesignAndDevelopment />}
            />
            <Route path="/erp" element={<Erp />} />
            <Route
              path="/hosting-cloud-services"
              element={<HostingAndCloudServices />}
            />
            <Route
              path="/custom-plugin-app-development"
              element={<PluginAndAppDevelopment />}
            />
            <Route
              path="/performance-marketing"
              element={<PerformanceMarketing />}
            />
            <Route
              path="/performance-marketing_ny"
              element={<PerformanceMarketing_ny />}
            />
            <Route
              path="/performance-marketing-Texas"
              element={<PerformanceMarketing_Texas />}
            />
            <Route path="/tiktok-marketing-services" element={<Tiktok />} />
            <Route
              path="/search-engine-optimization-services"
              element={<Seo />}
            />
            <Route
              path="/search-engine-optimization-services-ny"
              element={<Seo_ny />}
            />
            <Route
              path="/search-engine-optimization-services-Texas"
              element={<Seo_Texas />}
            />
            <Route
              path="/influencer-marketing-services"
              element={<InfluencerMarketing />}
            />
            <Route
              path="/digital-marketing-services"
              element={<SocialMediaMarketing />}
            />
            <Route
              path="/email-marketing-services"
              element={<EmailMarketing />}
            />
            <Route
              path="/conversion-rate-optimization-services"
              element={<ConversionRateOptimization />}
            />
            <Route
              path="/logo-branding-services"
              element={<LogoAndBranding />}
            />
            <Route
              path="/graphic-designing-services"
              element={<PrintDesignAndService />}
            />
            <Route
              path="/product-merchandise"
              element={<ProductAndMerchandise />}
            />
            <Route
              path="/Banners-and-advertisement"
              element={<BannersAndAdvertisement />}
            />
            <Route path="/ui-ux-design-services" element={<UiAndUxDesign />} />
            <Route
              path="/staff-augmentation-service"
              element={<StaffAugmentationService />}
            />
            <Route
              path="/project-outsourcing"
              element={<ProjectOutsourcing />}
            />
            <Route path="/cctv" element={<CctvSurveillance />} />
            <Route path="/ai-in-ecommerce" element={<AiInEcommerce />} />
            <Route path="/virtual-assistant" element={<VirtualAssistant />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/testimonial" element={<Testimonial />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:handle" element={<BlogDetailsCard />} />
            <Route path="/career" element={<Career />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-mean3" element={<ContactUs />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/news-and-pr" element={<News />} />
            <Route
              path="/influencer-registration-form"
              element={<InfluencerRegistrationForm />}
            />
            <Route path="/media" element={<Media />} />
            <Route path="/csvgo-privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/urban-pick-privacy-policy"
              element={<PrivacyPolicy1 />}
            />
            <Route
              path="/ofs-backsort-privacy-policy"
              element={<OFSBackSortPrivacyPolicy />}
            />
            <Route
              path="/privacy-policy-optimum-checkout"
              element={<OptimumCheckout />}
            />
            <Route
              path="/privacy-policy-smart-stock"
              element={<SmartStockPrivacyPolicy />}
            />
            <Route
              path="/privacy-policy-smart-campaign"
              element={<SmartCampaignPrivacyPolicy />}
            />
            <Route
              path="/privacy-policy-employee-discount"
              element={<EmployeeDiscountPrivacyPolicy />}
            />
            <Route
              path="/privacy-policy-eoceanapp"
              element={<EoceanPrivacyPolicy />}
            />
            <Route
              path="/fake-order-shield-privacy-policy"
              element={<FakeOrderShield />}
            />
            <Route
              path="/checkout-boost-privacy-policy"
              element={<CheckoutBoostPrivacyPolicy />}
            />
            <Route
              path="/bulk-gift-privacy-policy"
              element={<BulkGiftPrivacyPolicy />}
            />
            <Route
              path="/pingme-backinstock-privacy-policy"
              element={<PingMePrivacyPolicy />}
            />
            <Route path="/author/:username" element={<UserProfilePage />} />
            <Route path="/nyc" element={<WebNewYorkPage />} />
            {/* 404 catch-all route */}
            <Route path="*" element={<NotFound />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="blogs" element={<AdminBlogs />} />
              <Route element={<RoleRoute allowedRoles={["admin", "dev"]} />}>
                <Route path="/admin/users" element={<AdminUsers />} />
              </Route>
            </Route>
          </Route>
        </Routes>
        <FloatingButtons />
      </BrowserRouter>
      
    </div>
  );
}

export default App;
